
import { IEntityMetaData, IPropretyAttribute } from "../../../_models/IEntityMetaData";
import { PropretyAttributes, NestedProperty } from "../../../decorators/EntityDecorators";
import { Event } from "../Event.model";
import { Employee } from "../Employee.model";
import { GenericEntityBase } from "../../../_models/GenericEntityBase";

export class Evt_Employee extends GenericEntityBase<string> {
  private _id?: string = undefined; 
  override get id(): string {
    if (this._id == null) {
      this._id = `${this.fK_Event}-${this.fK_Employee}`; 
    }
    return this._id;
  }

  override _isRelationEntity = true; 

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Event!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.KeyProperty] })
  fK_Employee!: number;

  @NestedProperty({ TargetType: Event })
  event?: Event;

  @NestedProperty({ TargetType: Employee })
  employee?: Employee;

  GetType(): IEntityMetaData {
    return Evt_Employee.getMetaData();
  }
}
